import type { HydratedUser, TokenPayload } from "@packsize/identity-api-sdk";
import { hasLicense } from "@packsize/authentication";

import {
	hasAnyDashboardPermission,
	hasAnyOperatorPermission,
	hasAnyReportingPermission,
} from "@/views/configuration/roles/role-utils";

const SITE_SELECT_SHOWN_KEY = "siteSelectShown";

const getDefaultDestination = (user: HydratedUser): string => {
	const hasShownSiteSelect = sessionStorage.getItem(SITE_SELECT_SHOWN_KEY) === "true";
	const hasMultipleTenants = user.userTenants.length > 1;

	if (hasShownSiteSelect === false && hasMultipleTenants) {
		return "/site-select";
	}

	if (hasAnyDashboardPermission(user.permissions) && hasLicense(user, "Core", "basic", "ff-pack-net-dashboard")) {
		return "/dashboard";
	}

	if (hasAnyOperatorPermission(user.permissions)) {
		return "/production";
	}

	if (hasAnyReportingPermission(user.permissions)) {
		return "/reporting";
	}

	return "/invalid-access";
};

const getReturnToDestination = (user: HydratedUser, returnTo: string): string => {
	if (returnTo.toLowerCase().startsWith("/site-select")) {
		return returnTo;
	}

	const hasShownSiteSelect = sessionStorage.getItem(SITE_SELECT_SHOWN_KEY) === "true";
	const hasMultipleTenants = user.userTenants.length > 1;

	if (hasShownSiteSelect === false && hasMultipleTenants) {
		return "/site-select?returnTo=" + encodeURIComponent(returnTo);
	}

	return returnTo;
};

export const getLoginDestination = (
	user: HydratedUser | null,
	_decodedToken: TokenPayload | null,
	returnTo: string | null,
): string => {
	if (user === null) {
		return "/login";
	}

	if (returnTo) {
		return getReturnToDestination(user, returnTo);
	}

	return getDefaultDestination(user);
};
